import * as React from 'react';
import { CommonProps } from './common.intefaces';
import Select from 'antd/lib/select';

interface IProps extends CommonProps {
  locations: string[];
}

const SelectStuffing = (props: IProps) => {

  const {
    mode,
    style,
    value,
    onChange,
    disabled,
    className,
    placeholder,
    locations,
  } = props;

  const renderPDOptions = () => {
    return locations?.map((item) => <Select.Option
      key={item}
    >
      {item}
    </Select.Option>) || [];
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    value={value}
    disabled={disabled}
    onChange={onChange}
    className={className}
    mode={mode || 'default'}
    placeholder={placeholder || 'Select Location'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderPDOptions()}
  </Select>;
};

export default React.memo(SelectStuffing);
